export enum IDENTITY_PROVIDERS {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=24689031
     */
    LOGIN_BUTTON_INFO = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.LOGIN_BUTTON_INFO',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=36893963
     */
    SAVE_SUCCESS = 'ADMIN.PROVIDER.SAVE.SUCCESS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=36893978
     */
    DELETE_ERROR = 'ADMIN.PROVIDER.DELETE.ERROR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=36893976
     */
    DELETE_SUCCESS = 'ADMIN.PROVIDER.DELETE.SUCCESS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=41414882
     */
    SAVE_DOMAIN_ERROR = 'ADMIN.PROVIDER.SAVE.DOMAIN_ERROR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=50684286
     */
    QUOTA_EXCEED = 'ADMIN.PROVIDER.QUOTA.EXCEED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=38622933
     */
    DOWNLOAD_SP_ERROR = 'ADMIN.PROVIDER.DOWNLOAD_SP.ERROR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=42171519
     */
    SERVICE_FETCH_PROVIDER_ERROR = 'ADMIN.PROVIDER.SERVICE.FETCH_PROVIDER_ERROR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=42171524
     */
    SERVICE_FETCH_USERSPACE_ERROR = 'ADMIN.PROVIDER.SERVICE.FETCH_USERSPACE_ERROR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=42171521
     */
    SERVICE_FETCH_USERSPACE_DETAIL_ERROR = 'ADMIN.PROVIDER.SERVICE.FETCH_USERSPACE_DETAIL_ERROR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=42509244
     */
    SERVICE_SAVE_USERSPACE_SUCCESS = 'ADMIN.PROVIDER.SERVICE.SAVE_USERSPACE_SUCCESS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=42509245
     */
    SERVICE_SAVE_USERSPACE_ERROR = 'ADMIN.PROVIDER.SERVICE.SAVE_USERSPACE_ERROR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=36893965
     */
    SAVE_ERROR = 'ADMIN.PROVIDER.SAVE.ERROR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=42509288
     */
    SERVICE_DELETE_USERSPACE_SUCCESS = 'ADMIN.PROVIDER.SERVICE.DELETE_USERSPACE_SUCCESS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=42509289
     */
    SERVICE_DELETE_USERSPACE_ERROR = 'ADMIN.PROVIDER.SERVICE.DELETE_USERSPACE_ERROR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=245751653
     */
    PROVISIONING_URL = 'ADMIN.PROVIDER.PROVISIONING_URL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=255673190
     */
    PROVISIONING_URL_INFO = 'ADMIN.PROVIDER.PROVISIONING_URL_INFO',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=255678714
     */
    SEE_OUR_DOC = 'ADMIN.GLOBAL.SEE_OUR_DOC',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=242950491
     */
    PROV_FEDERATION_ERROR_BEGIN = 'PROV_FEDERATION.ERROR_BEGIN',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=242951037
     */
    PROV_FEDERATION_ERROR_END = 'PROV_FEDERATION.ERROR_END',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=242950409
     */
    PROV_FEDERATION_SUCCESS = 'PROV_FEDERATION.SUCCESS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=255678698
     */
    SYNC_APPLICATION_ONLY_WARNING = 'ADMIN.PROVIDER.SYNC_APPLICATION_ONLY_WARNING',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=255678733
     */
    PROVISIONING_SOURCE_ERROR = 'ADMIN.PROVIDER.PROVISIONING_SOURCE_ERROR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=277955369
     * @deprecated use ReferToDocumentation component instead
     */
    FOR_MORE_INFO_REFER_TO = 'ADMIN.PROVIDER.FOR_MORE_INFO_REFER_TO',
    /**    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=376621256
     */
    PROVISIONING_URL_MISSING = 'ADMIN.PROVIDER.PROVISIONING_URL_MISSING',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=433051050
     */
    EXTRANET_VISIBILITY_PLATFORM_HELPER = 'ADMIN.PROVIDER.VISIBILITY_PLATFORM_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=433051060
     */
    EXTRANET_VISIBILITY_INSTANCE_HELPER = 'ADMIN.PROVIDER.VISIBILITY_INSTANCE_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=433051064
     */
    EXTRANET_INSTANCE_PICKER_LABEL = 'ADMIN.PROVIDER.INSTANCE_PICKER_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=433051099
     */
    EXTRANET_GROUP_PICKER_LABEL = 'ADMIN.PROVIDER.GROUP_PICKER_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=433051133
     */
    EXTRANET_GROUP_PICKER_HELPER = 'ADMIN.PROVIDER.GROUP_PICKER_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=433051041
     */
    EXTRANET_FEATURE = 'ADMIN.PROVIDER.EXTRANET_OPTION_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=484897000
     */
    DISABLE_PROVISIONING_WARNING = 'ADMIN.PROVIDER.DISABLE_PROVISIONING_WARNING',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=36893487
     */
    TABLE_HEADER_ACTION = 'ADMIN.PROVIDER.TABLE_HEADER_ACTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29647125
     */
    TABLE_HEADER_PROVIDER = 'ADMIN.PROVIDER.TABLE_HEADER_PROVIDER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29647128
     */
    TABLE_HEADER_LAST_SYNC = 'ADMIN.PROVIDER.TABLE_HEADER_LAST_SYNC',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=497187078
     */
    EMPTY_STATE_TITLE = 'PROVIDERS.EMPTY_STATE_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=497187082
     */
    EMPTY_STATE_DESCRIPTION = 'PROVIDERS.EMPTY_STATE_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=144199544
     */
    EDIT_PROVIDER_INFO_MESSAGE = 'ADMIN.PROVIDER.INFO_MESSAGE.EDIT_PROVIDER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=144199683
     */
    EDIT_PROVIDER_LINK_TEXT = 'ADMIN.PROVIDER.INFO_MESSAGE.EDIT_PROVIDER_LINK_TEXT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=42164621
     */
    IDP = 'ADMIN.NAV.PROVIDER.IDP',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29552019
     */
    PROVIDER_MANAGEMENT = 'ADMIN.PROVIDER.PROVIDER_MANAGEMENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29647080
     */
    DELETE_CONFIRM_TITLE = 'ADMIN.PROVIDER.DELETE_CONFIRM_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29647087
     */
    DELETE_CONFIRM_CONTENT = 'ADMIN.PROVIDER.DELETE_CONFIRM_CONTENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29552028
     */
    NEW_PROVIDER = 'ADMIN.PROVIDER.NEW_PROVIDER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=36956357
     */
    EDIT_PROVIDER = 'ADMIN.PROVIDER.EDIT_PROVIDER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=78228354
     */
    LOGIN_HINT_ENABLED = 'ADMIN.PROVIDER.LOGIN_HINT_ENABLED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=78228355
     */
    LOGIN_HINT_HELPER = 'ADMIN.PROVIDER.LOGIN_HINT_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=78228356
     */
    AUTHENTICATE_EACH_LOGIN_ENABLED = 'ADMIN.PROVIDER.AUTHENTICATE_EACH_LOGIN_ENABLED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=78228357
     */
    AUTHENTICATE_EACH_LOGIN_HELPER = 'ADMIN.PROVIDER.AUTHENTICATE_EACH_LOGIN_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=78228352
     */
    REDIRECT_ENABLED = 'ADMIN.PROVIDER.REDIRECT_ENABLED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=78228353
     */
    REDIRECT_HELPER = 'ADMIN.PROVIDER.REDIRECT_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=52424219
     */
    LOGIN_ENABLED = 'ADMIN.PROVIDER.LOGIN_ENABLED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=52424231
     */
    LOGIN_ENABLED_HELPER = 'ADMIN.PROVIDER.LOGIN_ENABLED_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29648137
     */
    AUTO_SYNC_LABEL = 'ADMIN.PROVIDER.AUTO_SYNC_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29645342
     */
    AUTO_SYNC_HELPER = 'ADMIN.PROVIDER.AUTO_SYNC_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29652058
     */
    CRED = 'ADMIN.PROVIDER.CRED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29652006
     */
    CRED_CLIENT_ID = 'ADMIN.PROVIDER.CRED_CLIENT_ID',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29651994
     */
    CRED_CLIENT_ID_HELPER = 'ADMIN.PROVIDER.CRED_CLIENT_ID_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29651998
     */
    CRED_SECRET = 'ADMIN.PROVIDER.CRED_SECRET',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29651989
     */
    CRED_SECRET_HELPER = 'ADMIN.PROVIDER.CRED_SECRET_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29645303
     */
    EXCEPTIONS = 'ADMIN.PROVIDER.EXCEPTIONS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=148982941
     */
    EXCEPTIONS_FIELD_CONDITION = 'ADMIN.PROVIDER.EXCEPTIONS_FIELD_CONDITION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29647056
     */
    EXCEPTIONS_FIELD_NAME = 'ADMIN.PROVIDER.EXCEPTIONS_FIELD_NAME',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29645284
     */
    EXCEPTIONS_FIELD_TYPE = 'ADMIN.PROVIDER.EXCEPTIONS_FIELD_TYPE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29645300
     */
    EXCEPTIONS_FIELD_VALUE = 'ADMIN.PROVIDER.EXCEPTIONS_FIELD_VALUE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29645277
     */
    EXCEPTIONS_HELPER = 'ADMIN.PROVIDER.EXCEPTIONS_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=58815081
     */
    HAS_INTEGRATION_ONLY = 'ADMIN.PROVIDER.HAS_INTEGRATION_ONLY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=58815084
     */
    HAS_INTEGRATION_ONLY_HELPER = 'ADMIN.PROVIDER.HAS_INTEGRATION_ONLY_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29648027
     */
    MICROSOFT_HELPER = 'ADMIN.PROVIDER.MICROSOFT.HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29645311
     */
    OPTIONS = 'ADMIN.PROVIDER.OPTIONS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=176433582
     */
    PROVIDER_AUTO_LOGIN_REDIRECT_HELPER = 'ADMIN.PROVIDER.AUTO_LOGIN_REDIRECT_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=175310119
     */
    PROVIDER_LOGIN_REDIRECT = 'ADMIN.PROVIDER.LOGIN_REDIRECT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=175310384
     */
    PROVIDER_LOGIN_REDIRECT_HELPER = 'ADMIN.PROVIDER.LOGIN_REDIRECT_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=182272596
     */
    PROVIDER_LOGIN_VISIBILITY_HELPER = 'ADMIN.PROVIDER.LOGIN_VISIBILITY_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=182272339
     */
    PROVIDER_LOGIN_VISIBILITY_LABEL = 'ADMIN.PROVIDER.LOGIN_VISIBILITY_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=11660319
     */
    PROVIDER_SELECT_VALUE = 'GLOBAL.INPUT.SELECT_VALUE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=49870460
     */
    PROVISIONING_ENABLED = 'ADMIN.PROVIDER.PROVISIONING_ENABLED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=49870470
     */
    PROVISIONING_ENABLED_HELPER = 'ADMIN.PROVIDER.PROVISIONING_ENABLED_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29645316
     */
    SOURCE = 'ADMIN.PROVIDER.SOURCE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29645355
     */
    SSO_ENABLED = 'ADMIN.PROVIDER.SSO_ENABLED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29645369
     */
    SSO_ENABLED_HELPER = 'ADMIN.PROVIDER.SSO_ENABLED_HELPER',
    /**
     * https://app.lokalise.com/project/13393319
     */
    SYNC_TO_GSUITE = 'ADMIN.PROVIDER.SYNC_TO_GSUITE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=42039154
     */
    TECHNICAL_ACCOUNT_HELPER = 'ADMIN.PROVIDER.TECHNICAL_ACCOUNT.HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29647046
     */
    TECHNICAL_ACCOUNT = 'ADMIN.PROVIDER.TECHNICAL_ACCOUNT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=64229243
     */
    USE_BOOKMARKS = 'ADMIN.PROVIDER.USE_BOOKMARKS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=64229309
     */
    USE_BOOKMARKS_HELPER = 'ADMIN.PROVIDER.USE_BOOKMARKS_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=35116284
     */
    CUSTOMER_LOGIN_DOMAIN = 'ADMIN_RESELLER_CONSOLE_CUSTOMER_LOGIN_DOMAIN',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=33483110
     */
    CUSTOMER_SYNC_HIDE_USER = 'ADMIN_RESELLER_CONSOLE_CUSTOMER_SYNC_HIDE_USER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=33483111
     */
    CUSTOMER_SYNC_HIDE_USER_HELP = 'ADMIN_RESELLER_CONSOLE_CUSTOMER_SYNC_HIDE_USER_HELP',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=69907304
     */
    FEDERATE_ON_EMPLOYEEID = 'ADMIN.PROVIDER.FEDERATE_ON_EMPLOYEEID',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=69907305
     */
    FEDERATE_ON_EMPLOYEEID_HELPER = 'ADMIN.PROVIDER.FEDERATE_ON_EMPLOYEEID_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=41310376
     */
    VALIDATION_AFTER_SAVING = 'ADMIN.PROVIDER.DOMAIN.VALIDATION_AFTER_SAVING',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=41309060
     */
    VERIF_AFTER_LOGIN = 'ADMIN.PROVIDER.DOMAIN.VERIF_AFTER_LOGIN',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=182274516
     */
    PROVIDER_LOGIN_VISIBILITY_MOBILE = 'ADMIN.PROVIDER.LOGIN_VISIBILITY_MOBILE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=182274487
     */
    PROVIDER_LOGIN_VISIBILITY_WEB = 'ADMIN.PROVIDER.LOGIN_VISIBILITY_WEB',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=182274635
     */
    PROVIDER_LOGIN_VISIBILITY_WEBANDMOBILE = 'ADMIN.PROVIDER.LOGIN_VISIBILITY_WEBANDMOBILE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=36616953
     */
    CUSTOMER_SSO_DOMAIN_HINT = 'ADMIN_RESELLER_CONSOLE_CUSTOMER_SSO_DOMAIN_HINT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29652017
     */
    API_TOKEN = 'ADMIN.PROVIDER.API_TOKEN',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29652016
     */
    API_TOKEN_HELPER = 'ADMIN.PROVIDER.API_TOKEN_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=133199061
     */
    SYNC_APPLICATION_ONLY = 'ADMIN.PROVIDER.SYNC_APPLICATION_ONLY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=133199066
     */
    SYNC_APPLICATION_ONLY_HELPER = 'ADMIN.PROVIDER.SYNC_APPLICATION_ONLY_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=497880819
     */
    MOBILE_OKTA_CLIENT_ID_SDK = 'RESELLER_CONSOLE.MOBILE_OKTA_CLIENT_ID_SDK',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=497880827
     */
    MOBILE_OKTA_CLIENT_ID_SDK_HELPER = 'RESELLER_CONSOLE.MOBILE_OKTA_CLIENT_ID_SDK_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=497879782
     */
    MOBILE_OKTA_CRED_SDK = 'RESELLER_CONSOLE.MOBILE_OKTA_CRED_SDK',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=64481968
     */
    JIT_ENABLED = 'ADMIN.PROVIDER.JIT_ENABLED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=64481977
     */
    JIT_ENABLED_HELPER = 'ADMIN.PROVIDER.JIT_ENABLED_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=24523345
     */
    LOGIN_BUTTON = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.LOGIN_BUTTON',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=24523351
     */
    LOGIN_BUTTON_HELPER = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.LOGIN_BUTTON_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=24523353
     */
    UPLOAD_LOGO = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.UPLOAD_LOGO',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=24523893
     */
    BACKGROUND_COLOR = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.BACKGROUND_COLOR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=25829751
     */
    PROVIDER_URL_REFERENCE = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.PROVIDER_URL_REFERENCE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=13393319
     */
    METADATA_HELPER = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.METADATA_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=13341501
     */
    IMPORT_METADATA_HELPER = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.IMPORT_METADATA_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=13341505
     */
    EXPORT_METADATA_HELPER = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.EXPORT_METADATA_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=13259745
     */
    UPLOAD_METADATA = 'ADMIN.RESELLER_CONSOLE_CUSTOMER.UPLOAD_METADATA',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=74926850
     */
    SCIM_PROVIDER_TYPE = 'ADMIN.PROVIDER.SCIM_PROVIDER_TYPE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=74926855
     */
    SCIM_PROVIDER_TYPE_PLACEHOLDER = 'ADMIN.PROVIDER.SCIM_PROVIDER_TYPE_PLACEHOLDER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=167753986
     */
    IDENTITY_PROVIDER_INTERNAL = 'ADMIN.CUSTOMER.IDENTITY_PROVIDER_INTERNAL',
}
